import { cn } from "@/lib/utils";
import { LucideIcon, LucideProps } from "lucide-react";

interface WithIconProps extends React.HTMLAttributes<HTMLSpanElement> {
    icon: LucideIcon | React.ComponentType<LucideProps>;
    size?: number;
    iconClassName?: string;
    trailing?: boolean;
}

function Icon({ icon: Icon, size, className }: { icon: React.ComponentType<LucideProps>; size: number; className?: string }) {
    return <Icon className={cn(`h-${size}`, `w-${size}`, className)} />;
}

export function WithIcon({ icon, size, iconClassName, className, trailing = false, children, ...props }: WithIconProps) {
    return (
        <span className={cn("flex items-center space-x-2 text-nowrap", className)} {...props}>
            {!trailing && <Icon icon={icon} size={size ?? 4} className={iconClassName} />} <span>{children}</span> {trailing && <Icon icon={icon} size={size ?? 4} className={iconClassName} />}
        </span>
    );
}
